module.exports = __webpack_public_path__ + "components/advertise-header/static/c__card--1@2-2eadfd6455aba11fce9f88e72ab11227.jpg";